/* eslint-disable react-hooks/exhaustive-deps */
import { LayoutDataPage, LocalStorageKey } from "@/services/constants";
import { getLayout } from "@/services/services";
import { Center, Image, Loader, Stack } from "@mantine/core";
import { GetServerSideProps, InferGetServerSidePropsType } from "next";
import Head from "next/head";
import Router from "next/router";
import { useEffect, useState } from "react";

export const getServerSideProps = (async (context) => {
  const oldTenant = "";
  let hostNameUrl = context.req.headers.host || "";

  if (oldTenant) {
    const oldUrl = localStorage.getItem(oldTenant);
    hostNameUrl = oldUrl ? oldUrl : context.req.headers.host;
  } else {
    hostNameUrl = context.req.headers.host;
  }

  const layoutFromApi = await getLayout();
  let testLayout: LayoutDataPage | null = null;

  if (
    layoutFromApi &&
    layoutFromApi.layout &&
    Array.isArray(layoutFromApi.layout.pages) &&
    layoutFromApi.layout.pages.length > 0
  ) {
    testLayout = {
      url: hostNameUrl,
      page: null,
      config: layoutFromApi.layout.config,
      headers: layoutFromApi.layout.headers,
      footers: layoutFromApi.layout.footers,
      tenant: layoutFromApi.tenant,
    };
  }

  return {
    props: {
      hostNameUrl,
      testLayout,
    },
  };
}) satisfies GetServerSideProps<{
  hostNameUrl: string;
  testLayout: LayoutDataPage | null;
}>;

export default function Index({
  hostNameUrl,
  testLayout,
}: InferGetServerSidePropsType<typeof getServerSideProps>) {
  console.log("hostNameUrl", hostNameUrl);

  const mappingLanguage = {
    "en-US": "en",
    "vi-VN": "vi",
  };
  const [config, setConfig] = useState({
    favicon: "",
    logo: "",
    primaryColor: "",
    titleHead: "Ehiring Portal",
  });

  useEffect(() => {
    const { pathname } = Router;
    const oldTenant: string | null = localStorage.getItem(
      LocalStorageKey.TENANT,
    );
    const hostNameUrl = window.location.host;
    getLayout().then((layoutFromApi) => {
      if (layoutFromApi) {
        const root = document.documentElement;

        const newTenant = layoutFromApi.tenant;
        if (
          newTenant.length > 0 &&
          ((oldTenant && newTenant !== oldTenant) || oldTenant === null)
        ) {
          localStorage.setItem(LocalStorageKey.TENANT, newTenant);
          localStorage.setItem(newTenant, hostNameUrl);
        }

        const layout = layoutFromApi.layout;
        const tempConfig = {
          ...layout.config,
          titleHead: layout.config.titleHead || "Ehiring Portal",
        };
        const tempPage = layout.headers.find((e: any) => e.sort === 1);
        setConfig(tempConfig);
        root.style.setProperty("--primaryColor", tempConfig.primaryColor);
        root.style.setProperty("--secondaryColor", tempConfig.secondaryColor);
        const redirectTo = () => {
          if (tempConfig.defaultLanguage) {
            Router.push(
              `/${
                mappingLanguage[
                  tempConfig.defaultLanguage as keyof typeof mappingLanguage
                ]
              }${tempConfig.defaultHref}`,
            );
          } else {
            Router.push(tempConfig.defaultHref);
          }
        };
        setTimeout(redirectTo, 300);
      } else {
        setTimeout(() => {
          Router.push("/home");
        }, 300);
      }
    });
  }, []);
  return (
    <>
      <Head>
        <title>{testLayout?.config?.metaTitle || "Ehiring portal"}</title>
        <meta
          name="description"
          content={testLayout?.config?.metaDescription || "Build your portal"}
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <link rel="icon" href={testLayout?.config?.favicon} />
        <meta
          name="google-site-verification"
          content={testLayout?.config?.googleSiteVerification}
        />
        <meta property="og:site_name" content={testLayout?.config?.metaTitle} />
        <meta property="og:title" content={testLayout?.config?.metaTitle} />
        <meta
          property="og:description"
          content={testLayout?.config?.metaDescription || "Trang CMS"}
        />
        <meta
          property="og:image"
          content={testLayout?.config?.metaImage || testLayout?.config?.logo}
        ></meta>
      </Head>
      {/* <main>
            <Carousel />
            </main> */}
      <Center style={{ height: "100vh" }}>
        <Stack>
          {config.logo !== "" ? (
            <Center>
              <Image src={config.logo} alt="" style={{ maxWidth: 500 }} />
            </Center>
          ) : (
            <></>
          )}

          <Center>
            <Loader
              variant="dots"
              color={config ? config.primaryColor : "blue"}
            />
          </Center>
        </Stack>
      </Center>
    </>
  );
}
